import { render, staticRenderFns } from "./Cart-user.vue?vue&type=template&id=032edd7c"
import script from "./Cart-user.vue?vue&type=script&lang=js"
export * from "./Cart-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports